import './fondazioni-list.scss';

import enquire from 'enquire.js';
import { Responsive } from '../utils';

const COMPONENT_NAME = 'fondazioni-list';

const BEM = {
  BLOCK: COMPONENT_NAME,
  FONDAZIONI_MOBILE: 'fondazioni-list__list-accordion',
};

/**
 * version    1.0
 * class      <type> (Footer)
 * classdesc  Main footer
 */
export class FondazioniList {
  constructor() {
    this._desktopFooterInitialized = false;
    this._findUIElements();
    this._bindEvents();
  }

  // private methods

  _findUIElements() {
    this._els = {
      fondazioniMobile: $(`.${BEM.FONDAZIONI_MOBILE}`),
    };
  }

  _bindEvents() {
    const self = this;
    enquire.register(`${Responsive.getBreakpointMaxMediaQuery('sm')}`, () => {
      self.initMobileAccordion();
    });
  }

  initMobileAccordion() {
    this._els.fondazioniMobile.addClass('accordion-collapse collapse');
  }
}
